import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { AuthProvider } from './context/auth'
import { APIProvider } from './context/api'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <AuthProvider>
    <APIProvider>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </APIProvider>
  </AuthProvider>,
)
